export default "__VITE_ASSET__BL2_I8mF__"